import React, { useEffect, useState } from "react";
import "./Previeweditmodal.css";
import { ReactComponent as CheckCircleIcon } from "./assets/checkcircleicon.svg";
import { ReactComponent as CloseIcon } from "./assets/closeicon.svg";

import Button from "@mui/material/Button";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useForm } from "react-hook-form";
import axiosInstance from "./utils/axios";

export default function AddUser(props: any) {
    const [loading, setLoading] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);
    const [name, setName] = useState("");

    const rowItem = props.getRowItem;
    useEffect(() => {
        // console.log("rowItem",rowItem);
        setrole(rowItem ? rowItem.role : "");
        setName(rowItem ? rowItem.name : "");
    }, [rowItem]);

    const [role, setrole] = useState(rowItem ? rowItem.setrole : "");
    const {
        register,
        handleSubmit,
        formState: { errors },
        clearErrors,
        reset,
    } = useForm({ shouldUnregister: true });

    const handleClose = () => {
        props.handleCloseDialog(false);
        reset();
        clearErrors();
        setisSuccess(false);
    };

    const onSubmit = (formdata: any) => {
        setLoading(true);
        let postUrl;
        let postMethod;
        let postData;
        if (!rowItem) {
            postUrl = "/userlist/add";
            postMethod = "POST";
            postData = formdata;
        } else {
            formdata.id = rowItem.id;
            postUrl = `/userlist/update/${rowItem.id}`;
            postMethod = "PUT";
            postData = formdata;
        }

        axiosInstance(postUrl, {
            method: postMethod,
            data: postData,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response: any) => {
                if (response) {
                    setisSuccess(true);
                    props.getuserList();
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const isValidEmail = (value: any) => {
        const pattern = /^[a-zA-Z0-9._-]+@comcast.com$/;
        return pattern.test(value.toLowerCase());
    };

    return (
        <div className="dialog-section" style={{ position: "relative" }}>
            <Dialog
                open={props.isuserEditDialogOpened}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
            >
                {!isSuccess ? (
                    <div>
                        <DialogTitle>Add Users</DialogTitle>
                        <CloseIcon
                            style={{
                                position: "absolute",
                                right: 18,
                                top: 10,
                                color: "#393939",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                handleClose();
                            }}
                        />

                        <DialogContent>
                            <form className="form-section">
                                <div className="form-row">
                                    <div className="label-section">
                                        <label>
                                            Full Name{" "}
                                            <span style={{ color: "#d32f2f" }}>
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div>
                                        <input
                                            className={
                                                errors.name
                                                    ? "input-section error"
                                                    : "input-section"
                                            }
                                            {...register("name", {
                                                required: true,
                                                onBlur: (e: any) => {
                                                    setName(e.target.value);
                                                },
                                            })}
                                            defaultValue={
                                                rowItem?.name
                                                    ? rowItem.name
                                                    : ""
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div
                                        className="row-column"
                                        style={{ marginRight: "14px" }}
                                    >
                                        <div className="label-section">
                                            <label>
                                                Email Id{" "}
                                                <span
                                                    style={{ color: "#d32f2f" }}
                                                >
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div>
                                            <input
                                                className={
                                                    errors.email
                                                        ? "input-section error"
                                                        : "input-section"
                                                }
                                                {...register("email", {
                                                    required: true,
                                                    validate: isValidEmail,
                                                })}
                                                defaultValue={
                                                    rowItem?.email
                                                        ? rowItem.email
                                                        : ""
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row-column">
                                        <div className="label-section">
                                            <label>
                                                Role{" "}
                                                <span
                                                    style={{ color: "#d32f2f" }}
                                                >
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div>
                                            <select
                                                className={
                                                    errors.role
                                                        ? "select-section error"
                                                        : "select-section"
                                                }
                                                {...register("role", {
                                                    required: true,
                                                })}
                                                onChange={(event) =>
                                                    setrole(event.target.value)
                                                }
                                                value={role}
                                            >
                                                <option value="">Select</option>
                                                <option value="superadmin">
                                                    Super admin
                                                </option>
                                                <option value="admin">
                                                    Admin
                                                </option>
                                                <option value="user">
                                                    User
                                                </option>
                                                <option value="panel">
                                                    Panel
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </DialogContent>
                        <div className="modalbtn-section">
                            <Button
                                variant="outlined"
                                sx={{
                                    textTransform: "capitalize",
                                    color: "#227AD2",
                                    borderColor: "#227AD2",
                                    width: "140px",
                                    marginRight: "12px",
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    textTransform: "capitalize",
                                    color: "#fff",
                                    background: "#227AD2",
                                    width: "140px",
                                }}
                                onClick={handleSubmit(onSubmit)}
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <DialogContent>
                            <div className="modalsuccess-section">
                                <div className="successicon-section">
                                    <CheckCircleIcon />
                                </div>
                                <div className="successcontent-section">
                                    The Referer User <strong>"{name}"</strong>{" "}
                                    was added successfully.
                                </div>
                                <div className="successclose-section">
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            textTransform: "capitalize",
                                            color: "#227AD2",
                                            borderColor: "#227AD2",
                                            padding: "5px 28px",
                                        }}
                                        onClick={() => {
                                            handleClose();
                                        }}
                                    >
                                        Close
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )}
                {loading ? (
                    <div className="load-spinner">
                        <CircularProgress size="4rem" sx={{ color: "#fff" }} />
                        <div className="spinner-text">
                            Loading Please Wait....
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </Dialog>
        </div>
    );
}
